const Review=[
    {
        img:'https://scontent.fktm8-1.fna.fbcdn.net/v/t39.30808-1/368209621_274080192017725_3251548434978028827_n.jpg?stp=dst-jpg_p480x480&_nc_cat=104&ccb=1-7&_nc_sid=5f2048&_nc_ohc=vnWnkO592_kAX9R6iOu&_nc_ht=scontent.fktm8-1.fna&oh=00_AfByIPn8j-6N69bMpKvPYEhI6u70Q3eyhfTZltpZMDv6SQ&oe=6611B4D4',
        contain: "Bikas's a clear communicator with the tenacity and confidence to really dig in to tricky design scenarios and the collaborative friction that's needed to produce excellent work. ",
        name: "Bikas"
    },
    {
        img: 'https://scontent.fktm8-1.fna.fbcdn.net/v/t39.30808-1/279114560_1007412136554652_1383538175679485539_n.jpg?stp=dst-jpg_s480x480&_nc_cat=110&ccb=1-7&_nc_sid=5f2048&_nc_ohc=imr08VLnjSwAX_KfoAU&_nc_ht=scontent.fktm8-1.fna&oh=00_AfDmm0LDdeEkmXHpjej7Her11Vf9_xSPcCZsKaIR1N-V0w&oe=6611D12D' ,
        contain: "Jenish was a real pleasure to work with and we look forward to working with him again. He’s definitely the kind of designer you can trust with a project from start to finish. ",
        name: "Jenish"
    }
]
export default Review